import WebAPI from "./api-calls";
import { rateHandler } from './rate-handler';

export const getDirectDebitWasteFeatureFlag = () => {
    const task = async (res, rej) => {

        const webApi = new WebAPI();
        await webApi.getFromWebApiWithAccessTokenAsync('/api/multiutility/direct-debit-waste-feature-flag')
            .then(resp => {
                res(resp);
            })
            .catch(err => {
                console.log('error response', err)
                if (err && err.response && err.response.status === 429) return rej(err);
                res({ success: true });
            });
    }
    return rateHandler(task);
}